import { Check } from "lucide-react";
import { MarktingCard } from "../../AvatarDigitalMarketer/AiMarketingTeam";
import Box from "../../components/Box";
import Text from "../../components/Text";
import Button from "../../components/Button";

const theSolution = [
    { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "Predicts issues before they affect school life" },
    { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "Fixes problems automatically" },
    { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "No tickets, no panics - just smooth operations" },
];

const schoolBenefits = [{
    title: "Classes Stop",
    description: "Outages distract teachers and students.",
    cName: "text-center"
}, {
    title: "Parents Wait",
    description: "Delays harm trust and communication.",
    cName: "text-center"
}, {
    title: "Staff Struggle",
    description: "One person ends up doing many jobs.",
    cName: "text-center"
}, {
    title: "The Solution: AI That Handles Everything",
    description: "SooMuch.ai is your self-healing support system. It predicts, fixes, and prevents problems — quietly working 24×7×365 so learning never stops.",
    footer: <div className="space-y-3">
        {theSolution.map((section, index) => (
            <div key={"f" + index} className="flex items-center gap-3">
                {!!section.icon && section.icon}
                <Text label={section.text} cName="text-gray-700 text-xs font-semibold leading-relaxed" />
            </div>
        ))}
    </div>
}, {
    title: "Onboarding in Under 10 Minutes",
    description: "No manual setup, no tech skills needed. Upload your logo and photos — the system goes live. A virtual relationship manager is ready if you need help.",
    footer: <Button label='Get Started - It takes 10 minutes' type='gradient' />,
    footerClass: "mt-auto"
}];


export default function ProblemSchoolFaces() {

    return (
        <Box
            badge={"WHY YOU NEED US"}
            title={"The Problem Schools Face"}
            description={"Schools deserve better than constant firefighting. When systems break, classes stop, parents wait, and staff spend time fixing tech instead of teaching."}
            leftBlock={
                <div className='col-span-2 md:col-span-1'>
                    {/* <div className="grid grid-cols-3 mt-8 gap-6"> */}
                    <div className="grid grid-cols-3 md:grid-cols-1 gap-6">
                        {schoolBenefits.slice(0, 3).map((member, index) => <MarktingCard key={"memberasdsadInnerCard" + index} member={member} />)}
                    </div>
                </div>
            }
            rightBlock={schoolBenefits.slice(3).map((member, index) => <MarktingCard key={"memberUpperCardIN" + index} member={member} />)}
        />
    );
}